// Project keys to segment feedbacks under the same JSM project
export const CardBackFeedbackKey = 'card-back';
export const GlobalFeedbackKey = 'global';
export const InboxFeedbackKey = 'inbox';
export const PlannerFeedbackKey = 'planner';
export const QuickCaptureFeedbackKey = 'quick-capture';
export const SplitScreenFeedbackKey = 'split-screen';
export const FocusModeFeedbackKey = 'focus-mode';
